import { persistStore, persistReducer /*, REHYDRATE */ } from './persist';
import debug from './debug';
//import { crosstabSync } from 'crosstab';
import storage from '../storage';
import appReducer from '../reducer';
import ormReducer from '../orm';
import venueReducer from '../venue';
import actions from '../actions';

import engineIo from 'engine.io-client';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import uuid from 'uuid/v4';
import { get, invoke, mapValues } from 'lodash';
import assert from 'assert';

const reducers = {
  app: appReducer,
  orm: ormReducer,
  venue: venueReducer,
};

const rootReducer = combineReducers(
  mapValues(reducers, (reducer, key) =>
    persistReducer({ key, storage }, reducer),
  ),
);

console.error('Should have try/catch around JSON.parse/JSON.strintify too!');
const connectionMiddleware = store => {
  let socket;
  let unsubscribe;

  const disconnect = () => {
    debug('disconnecting socket');
    invoke(socket, 'close');
    socket = undefined;
  };

  const connect = ({ address, roomKey }) => {
    if (socket) disconnect();

    debug('connecting socket to "%s"', address);
    socket = new engineIo.Socket(address, {
      path: '/api/connect',
    });

    socket.on('open', () => {
      debug('socket connected');
      store.dispatch(actions.connected({ address, roomKey }));
    });

    socket.on('close', reason => {
      debug('socket disconnected: %s', reason);
      store.dispatch(actions.disconnected({ address, roomKey, reason }));
      invoke(unsubscribe);
    });

    socket.on('error', error => {
      console.error('Error: Socket error\n', error);
    });

    socket.once('message', message => {
      const action = JSON.parse(message);
      assert(action.type === '@@nosturi/server/INIT');
      assert(action.payload.version === 1);
      debug('got "INIT" action: %o', action);

      socket.on('message', message => {
        const action = JSON.parse(message);
        const { ack } = action.meta || {};
        if (ack) {
          debug('received ACK from socket: %o', action);
        } else {
          debug('received action from socket: %o', action);
          store.dispatch({
            ...action,
            meta: { ...action.meta, remote: true },
          });
        }
      });
    });
  };

  const send = action => {
    if (!socket) return;

    debug('emitting action to socket: %o', action);
    socket.send(
      JSON.stringify({
        ...action,
        meta: { ...action.meta, uuid: uuid() },
      }),
    );
  };

  return next => action => {
    const { remote, local } = get(action, 'meta', {});
    if (remote) {
      switch (action.type) {
        case String(actions.connected): {
          debug('a peer connection detected! %o', action.payload);
          const state = store.getState();
          for (const key of ['orm', 'venue'])
            send(actions.reset(key, state[key]));
          break;
        }
        default:
          break;
      }
      return next(action);
    }

    switch (action.type) {
      case String(actions.connect): {
        connect(action.payload);
        break;
      }
      case String(actions.disconnect): {
        disconnect();
        break;
      }
      default:
        break;
    }

    if (!local) send(action);

    return next(action);
  };
};

const configureStore = (mode, initialState = {}) => {
  const middlewares = [thunk, connectionMiddleware];

  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares)),
  );

  const persistor = persistStore(
    { keys: Object.keys(reducers), storage },
    store,
  );
  //crosstabSync(persistor);
  return { store, persistor };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js